function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "Icons Big/ic_big_check");

var _ref3 = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.");

var _ref4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  d: "M36,6 C19.4314606,6 6,19.4314699 6,36 C6,52.5684495 19.4315041,66 36,66 C52.5683952,66 66,52.5683952 66,36 C66,19.4315242 52.5684387,6 36,6 Z M36,10.3768997 C50.1512839,10.3768997 61.6231003,21.8487458 61.6231003,36 C61.6231003,50.1513153 50.1513153,61.6231003 36,61.6231003 C21.8487254,61.6231003 10.3768997,50.1512944 10.3768997,36 C10.3768997,21.8487666 21.8487567,10.3768997 36,10.3768997 Z M49.8644603,25.5760254 L32.590436,43.1318335 L23.0473926,33.4330176 L20.0819404,36.4468656 L32.5904421,49.1595325 L52.8299091,28.5898485 L49.8644603,25.5760254 Z",
  id: "path-1"
}));

var _ref5 = /*#__PURE__*/React.createElement("g", {
  id: "Icons-Big/ic_big_check",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("mask", {
  id: "mask-2",
  fill: "white"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#path-1"
})), /*#__PURE__*/React.createElement("g", {
  id: "Shape",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("g", {
  id: "\\u2731/Colors/Icon/Black/inactive",
  mask: "url(#mask-2)",
  fill: "#3D58D1",
  fillOpacity: 1
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle",
  x: 0,
  y: 0,
  width: 72,
  height: 72
})));

var SvgIcCheck = function SvgIcCheck(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "72px",
    height: "72px",
    viewBox: "0 0 72 72",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3, _ref4, _ref5);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcCheck, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ic_check.05cf3886.svg";
export { ForwardRef as ReactComponent };